module.exports = __webpack_public_path__ + "static/BrandonGrotesque-SemiBoldItalic-7fdaabffbdd2fb2bbd0fb1a48e5596a6.woff";